import { render } from "./ListEstoque.vue?vue&type=template&id=c2ecdf8e&scoped=true"
import script from "./ListEstoque.vue?vue&type=script&lang=js"
export * from "./ListEstoque.vue?vue&type=script&lang=js"

import "./ListEstoque.vue?vue&type=style&index=0&id=c2ecdf8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ecdf8e"]])

export default __exports__